/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_WarningInputs */



/**
* | output |
* | --- |
* | "Please leave this window open until syncing completes" |
*
* @param {Event_Group_Sync_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_warning = /** @type {((inputs?: Event_Group_Sync_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
	return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
});